/**
 * New console — signing out.
 *
 * The same two steps the classic console takes: tell the API, then drop the local
 * session. Skipping the API call would leave the token valid on the server. The lock
 * flag is cleared on the way out, because it outlives the session and the next person
 * to sign in on this browser would otherwise meet a lock screen belonging to nobody.
 *
 * One hook, because the account panel and the lock screen each carried a copy of this
 * and the two had already started to differ.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from '@hooks/useAuth';
import { logoutApi } from '@services/auth';

import { writeLocked } from './prefs';

const useSignOut = () => {
  const { setIsAuthenticated } = useAuth();
  const navigate = useNavigate();

  /** Resolves true once signed out; false when the API refused and nothing changed. */
  return useCallback(async () => {
    const res = await logoutApi();
    if (!res.isOk) return false;
    writeLocked(false);
    setIsAuthenticated(false);
    navigate('/login');
    return true;
  }, [setIsAuthenticated, navigate]);
};

export default useSignOut;
